import { render, staticRenderFns } from "./PersonProfileOverview.vue?vue&type=template&id=f70ee738&scoped=true&"
import script from "./PersonProfileOverview.vue?vue&type=script&lang=js&"
export * from "./PersonProfileOverview.vue?vue&type=script&lang=js&"
import style0 from "./PersonProfileOverview.vue?vue&type=style&index=0&id=f70ee738&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f70ee738",
  null
  
)

export default component.exports